import { CourseBannerProps } from '@components/learn/courseBanner/courseBannerTypes';
import { getPlatformUrl } from 'utils';

const convertCourseToBanner = (course: any): CourseBannerProps => {
    return {
        name: course.name,
        displayName: course.displayName,
        description: course.description,
        playNextLessonUrl: course?.nextLessonUrl ? `${getPlatformUrl()}${course?.nextLessonUrl}` : undefined,
        courseImage: course?.iconUrl ?? `${process.env.PUBLIC_URL}/images/courseDefaultCard.svg`,
        coins: course?.score,
        completionRate: course?.completionPercentage || course?.percent,
        navigateCoursePageUrl: `/app/course?courseUuid=${course?.uuid}`,
        useOverlay: Boolean(course?.iconUrl),
        uuid: course.uuid
    };
};

export default convertCourseToBanner;
